export default __webpack_public_path__ + "static/media/r5.1e65525b.jpg";